import { render, staticRenderFns } from "./ADescuento.vue?vue&type=template&id=1384016f"
import script from "./ADescuento.vue?vue&type=script&lang=js"
export * from "./ADescuento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports